import { useContext, useMemo } from "react";

import { WidgetOverflowMenuItemsContext } from "~/v3-poc/components/Widget";
import {
  OrdersDisplayMenuItems,
  type OrdersDisplayMenuItemsProps,
  OrdersDisplayMenuPresentation,
} from "./OrdersDisplayMenu.pres";

export type OrdersDisplayMenuProps = OrdersDisplayMenuItemsProps;

export const OrdersDisplayMenu = ({
  density,
  horizontalLines,
  verticalLines,
  onDensityChange,
  onHorizontalLinesChange,
  onVerticalLinesChange,
}: OrdersDisplayMenuProps) => {
  const overflowSlot = useContext(WidgetOverflowMenuItemsContext);
  const items = useMemo(
    () => (
      <OrdersDisplayMenuItems
        density={density}
        horizontalLines={horizontalLines}
        verticalLines={verticalLines}
        onDensityChange={onDensityChange}
        onHorizontalLinesChange={onHorizontalLinesChange}
        onVerticalLinesChange={onVerticalLinesChange}
      />
    ),
    [
      density,
      horizontalLines,
      onDensityChange,
      onHorizontalLinesChange,
      onVerticalLinesChange,
      verticalLines,
    ],
  );

  return (
    <OrdersDisplayMenuPresentation
      items={items}
      isOverflow={Boolean(overflowSlot)}
    />
  );
};
